import { requestApiJsonOrThrow } from '../request-handler'

export type MatchExclusion = {
  operatorExcluded: boolean
  sourceInvalid: boolean
  excludedFromScout: boolean
}

export function updateMatchExclusion(matchId: string, excluded: boolean) {
  return requestApiJsonOrThrow<{ id: string; exclusion: MatchExclusion }>(`admin/matches/${matchId}/exclusion`, {
    method: 'PATCH',
    body: { excluded },
  })
}
